import { IAppStore } from './store';
import { hideOfferSaga } from '../../serp/state/hide_offer';
import { agentRatingSaga } from '../../serp/state/offer_card/agent';
import { offerCommentsSaga } from '../../serp/state/offer_card/comments';
import { searchLayoutSaga } from '../../serp/state/searchLayout';
import { suggestionsDistacesSaga } from '../../serp/state/suggestions';

export function attachSagas(store: IAppStore) {
  store.runSaga(searchLayoutSaga);
  store.runSaga(offerCommentsSaga);
  store.runSaga(suggestionsDistacesSaga);
  store.runSaga(agentRatingSaga);
  store.runSaga(hideOfferSaga);
}
